import React from "react";
import Modal from "react-bootstrap/Modal";
import MaskedInput from "react-input-mask";
import CloseIcon from "@material-ui/icons/Close";

import {
  ModalContent,
  Filters,
  ButtonDays,
  Period,
  ButtonFilter,
  Datefield,
  DivisionRadio,
  Bottom,
  NumberInput,
  DivisionSeal
} from "./styles";
import iconfilter from "~/assets/images/filter_icon.svg";
import { Types } from "~/pages/GasVoucherList";

export default function ModalFilter({
  activeModal,
  activebeginDate,
  activeEndDate,
  changeFilter,
  changeFilterDate,
  showModal,
  beginDateFilter,
  endDateFilter,
  loadingPage,
  setFilterType,
  filterType,
  setSealNumber
}) {
  return (
    <Modal
      show={showModal}
      onHide={() => {
        activeModal();
      }}
      className="modal-vale-gas"
      centered={window.screen.width >= 768}
    >
      <Modal.Body style={{ padding: ".5rem", borderRadius: 15 }}>
        <ModalContent>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Filters
              style={{
                color: "#000FFF",
                fontSize: 18,
                fontWeight: "bold",
              }}
            >
              Filtros
            </Filters>
            <CloseIcon
              style={{ color: "#000FFF", cursor: "pointer" }}
              onClick={() => activeModal()}
            />
          </div>

          <div style={{ padding: 10 }}>
            <Period>Período:</Period>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "row",
              }}
            >
              <ButtonDays onClick={() => changeFilter(Types.DAYS_7)}>
                Últimos 7 dias
              </ButtonDays>
              <ButtonDays onClick={() => changeFilter(Types.DAYS_15)}>
                Últimos 15 dias
              </ButtonDays>
            </div>
            <div
              style={{
                marginTop: 16,
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "row",
              }}
            >
              <ButtonDays onClick={() => changeFilter(Types.DAYS_30)}>
                Últimos 30 dias
              </ButtonDays>
              <ButtonDays onClick={() => changeFilter(Types.DAYS_60)}>
                Últimos 60 dias
              </ButtonDays>
            </div>

            <hr />

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div>
                <Period>Data Inicial:</Period>
                <Datefield
                  onChange={async (event) =>
                    await activebeginDate(event.target.value)
                  }
                  value={beginDateFilter}
                  placeholder="--/--/----"
                  as={MaskedInput}
                  mask="99/99/9999"
                >
                  {(props) => {
                    const {
                      type,
                      name,
                      id,
                      placeholder,
                      value,
                      mask,
                      ...inputProps
                    } = props;
                    return (
                      <input
                        type={type}
                        name={name}
                        id={id}
                        placeholder={placeholder}
                        value={value}
                        {...inputProps}
                      />
                    );
                  }}
                </Datefield>
              </div>

              <div style={{ paddingLeft: ".7rem" }}>
                <Period>Data Final:</Period>
                <Datefield
                  as={MaskedInput}
                  onChange={async (event) =>
                    await activeEndDate(event.target.value)
                  }
                  value={endDateFilter}
                  placeholder="--/--/----"
                  mask="99/99/9999"
                >
                  {(props) => {
                    const {
                      type,
                      name,
                      id,
                      placeholder,
                      value,
                      mask,
                      ...inputProps
                    } = props;
                    return (
                      <input
                        type={type}
                        name={name}
                        id={id}
                        placeholder={placeholder}
                        value={value}
                        {...inputProps}
                      />
                    );
                  }}
                </Datefield>
              </div>
            </div>

            <hr />
            <Bottom>
              <DivisionSeal>
                <label for="seal">N° do lacre</label>
                <NumberInput
                  name="seal"
                  onChange={(e) => setSealNumber(e.target.value)}
                  placeholder="N° do lacre"
                />
              </DivisionSeal>
              <DivisionRadio>
                <div>
                  <input
                    name="todos"
                    type="radio"
                    onClick={() => setFilterType("Todos")}
                    checked={filterType === "Todos"}
                  />
                  <label for="emissao" onClick={() => setFilterType("Todos")}>Todos</label>
                </div>
                <div>
                  <input
                    name="aprovados"
                    type="radio"
                    onClick={() => setFilterType("Aprovados")}
                    checked={filterType === "Aprovados"}
                  />
                  <label for="vencimento" onClick={() => setFilterType("Aprovados")}>Aprovados</label>
                </div>
                <div>
                  <input
                    name="reprovados"
                    type="radio"
                    onClick={() => setFilterType("Reprovados")}
                    checked={filterType === "Reprovados"}
                  />
                  <label for="emissao" onClick={() => setFilterType("Reprovados")}>Reprovados</label>
                </div>
                <div>
                  <input
                    name="analise"
                    type="radio"
                    onClick={() => setFilterType("Em análise")}
                    checked={filterType === "Em análise"}
                  />
                  <label for="vencimento" onClick={() => setFilterType("Em análise")}>Em análise</label>
                </div>
                <div>
                  <input
                    name="analise"
                    type="radio"
                    onClick={() => setFilterType("Em aprovação")}
                    checked={filterType === "Em aprovação"}
                  />
                  <label for="vencimento" onClick={() => setFilterType("Em aprovação")}>Em aprovação</label>
                </div>
              </DivisionRadio>
            </Bottom>

            <ButtonFilter onClick={() => {
              changeFilterDate()
            }}>
              <img
                src={iconfilter}
                alt="Ícone de filtrar"
                style={{ margin: "0 -1.5rem 0 .8rem" }}
              />
              <span style={{ textAlign: "center", width: "100%" }}>
                {loadingPage ? (
                  <i className="fa fa-spinner fa-pulse fa-3x fa-fw" style={{ fontSize: "1rem" }} />
                ) : (
                  "Filtrar"
                )}
              </span>
            </ButtonFilter>
          </div>
        </ModalContent>
      </Modal.Body>
    </Modal>
  );
}
